import { call, put, getContext, takeLatest } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  getLikesListFailure,
  getLikesListPortionFailure,
  getLikesListPortionSuccess,
  getLikesListSuccess,
} from "./actions";
import {
  getLikesListActionTypes,
  getLikesListPortionActionTypes,
} from "./actionTypes";

const getLikesListAsync = ({ PostsService, id, params }) => {
  if (!PostsService) {
    console.log("Required services does not exist");
    return null;
  }

  return PostsService.getLikesList(id, params);
};

function* getLikesList({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getLikesListAsync, {
      PostsService,
      id,
      params,
    });

    yield put(getLikesListSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getLikesListFailure(error));
  }
}

function* getLikesListPortion({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getLikesListAsync, {
      PostsService,
      id,
      params,
    });

    yield put(getLikesListPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getLikesListPortionFailure(error));
  }
}

export function* watchGetLikesList() {
  yield takeLatest(getLikesListActionTypes.request, getLikesList);
}

export function* watchGetLikesListPortion() {
  yield takeLatest(getLikesListPortionActionTypes.request, getLikesListPortion);
}
